import {Link} from "react-router-dom";
import Button from "../../../../components/UI/Button";
import {checkPermission} from "../../../../util/auth";

const ProductListCardActions = () => {
  return(
      <h1 className="common_title ">

          <div className="d_flex_btwn">
              <span>Product List</span>
              {checkPermission(['PRODUCT_CREATE']) &&
              <span>
                  <Link to={'/products/add'}>
                    <button className="btn btn_md btn_black ml_5 pl_20 pr_20"> <span
                      className="mr_5 d_flex_center"><i
                      className="lni lni-plus"></i></span> Add Product</button>
                  </Link>
              </span>
              }
          </div>
      </h1>
  );
}

export default ProductListCardActions